import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
  },
  headline: {
    color: theme.palette.secondary.main,
    marginBottom: '2.5rem',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  zeroState: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  eventsWrapper: {
    display: 'grid',
    'grid-template-columns': 'repeat(auto-fill,minmax(300px, 1fr))',
    'grid-gap': '2rem',
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  mobileLoadMore: {
    display: 'flex',
    justifyContent: 'center',
  },
  categoryTagsRow: {
    display: 'flex',
    gap: '0.625rem',
    [theme.breakpoints.down('xs')]: {
      'overflow-x': 'scroll',
    },
  },
  categoryTags: {
    ...theme.typography.formTags,
    width: '135px',
    height: '45px',
    textAlign: 'center',
    borderRadius: '8px',
    whiteSpace: 'nowrap',
    fontSize: '14px',
    transition: '250ms',
    backgroundColor: theme.palette.offwhite.main,
    color: theme.palette.secondary.main,
    [theme.breakpoints.down('xs')]: {
      ...theme.typography.formLabel,
      flexShrink: '0',
      fontSize: '12px',
      width: '110px',
    },
    '&:hover, &:active': {
      textDecoration: 'none',
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.offwhite.main,
    },
  },
  active: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.offwhite.main,
  },
  divider: {
    width: '100%',
    opacity: '0.5',
    height: '1px',
    backgroundColor: theme.palette.grey.light,
  },
}))

export default useStyles
